var render = function render(_c,_vm){return _c('div',_vm._g(_vm._b({staticClass:"m-4 alert alert-info"},'div',_vm.data.attrs,false),_vm.listeners),[_c('span',{staticClass:"display-3 text-muted loading"},[_c('em',{staticClass:"fa fa-gears fa-spin"}),_vm._v(" Loading ...\n    "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }